import { Organization } from 'lib/types/company';
import { IThemeProperties } from 'lib/types/themes';
import { createContext, useContext } from 'react';

interface IWhiteLabelContext {
  coursePreviewImageSrc: string;
  faviconHref: string;
  helpCenterUrl: string;
  homePageName: string;
  howItWorksUrl: string;
  legalAndPrivacyUrl: string;
  organization: Organization;
  organizationName: string;
  organizationTheme: IThemeProperties;
  primaryColor: string;
  questionsEmail: string;
  supportEmail: string;
  survicateKey: string;
  termsOfServiceUrl: string;
}

export const WhiteLabelContext = createContext<IWhiteLabelContext>(null);

export const useWhiteLabelContext = () => useContext(WhiteLabelContext);
